var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll"},[_c('NavHeader'),_c('div',[_c('router-view')],1),_c('Footer'),_c('Backup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }